var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loading)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e(),(_vm.loading)?_c('spinner'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }